import { useState } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import DraggableModal from "../../generic/DraggableModal";
import Stack from "@mui/material/Stack";
import StyledButton from "../../generic/StyledButton";
import { backendPatchWithoutRefresh } from "../../../helpers/callBackend.js";
import InputAdornment from "@mui/material/InputAdornment";

const VerifyMicroDeps = ({
  visible,
  handleCancelModal,
  bankAccountId,
  bankAccountName,
  setFundingSourceIsVerified,
}) => {
  const [microDeps, setMicroDeps] = useState({
    amount1: 0,
    amount2: 0,
  });

  const textFieldProps = {
    defaultValue: "0.00",
    type: "number",
    size: "small",
    fullWidth: true,
    variant: "outlined",
    sx: {
      width: "100%",
    },
    InputProps: {
      disableUnderline: true,
      sx: {
        borderRadius: 0,
      },
    },
  };

  const handleInput = (event, key) => {
    let newMicroDeps = { ...microDeps };
    newMicroDeps[key] = event.target.value;
    setMicroDeps(newMicroDeps);
  };

  const handleSubmit = async () => {
    const verifyResp = await backendPatchWithoutRefresh(
      "/api/arpari-dwolla/funding-source/",
      {
        ...microDeps,
        bank_account_id: bankAccountId,
      }
    );
    if (verifyResp.status != 200) {
      return;
    }
    setFundingSourceIsVerified(true);
    handleCancelModal(false);
  };

  return (
    <DraggableModal
      modalTitle={`Enable Payments on ${bankAccountName}`}
      modalVisible={visible}
      handleCancelModal={handleCancelModal}
      width="50%"
      content={
        <Stack spacing={1}>
          <Typography>
            You should have received 2 microdeposits in your account. Please
            input the amounts below to verify your account to enable payments.
          </Typography>
          <Stack spacing={0.5} direction="row" alignItems="center">
            <Typography sx={{ width: "30%" }}>Amount 1</Typography>
            <TextField
              {...textFieldProps}
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              onChange={(event) => handleInput(event, "amount1")}
            />
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center">
            <Typography sx={{ width: "30%" }}>Amount 2</Typography>
            <TextField
              {...textFieldProps}
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              onChange={(event) => handleInput(event, "amount2")}
            />
          </Stack>
        </Stack>
      }
      actions={
        <StyledButton label="Submit" fontSize={14} onClick={handleSubmit} />
      }
    />
  );
};

export default VerifyMicroDeps;
